// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
import {
    faCode,
    faHighlighter,
    faPenToSquare,
    faFileLines,
    faTrash,
    faBell,
    faBars
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faCode,
    faHighlighter,
    faPenToSquare,
    faFileLines,
    faTrash,
    faBell,
    faPenToSquare,
    faBars,
    // more icons go here
);